import React from 'react'
import JoinRm from './JoinRm'
import Tabsi from './Tabs'

const Career = () => {
  return (
    <>
      <JoinRm />
      <Tabsi />
    </>
  )
}

export default Career